import api from "../../services/labourPalnningService";
import forecast_api from "../../services/forecastService";
import moment from 'moment';
import axios from 'axios';
import {EventBus} from "../../eventBus";
import router from '@/router';
const state = {
	stores_list:[],
	all_forecast_data:[],
	col_forecast_data:[],
	name_mapping_data:[],
	store_forecast_data:[],
    selected_store:'all',
    sfl_table_loading: false,
    is_store_level_table: false,
    selected_store_level: '',
    selected_store_id: '',
    set_selected_approve_date: '',
    store_events: [],
    event_categories: [],
    forecast_approve_data: {
        forecast: null,
        sale_week: null,
        sale_year: null
    },
    forecast_graph_data: [],
    forecast_popup_loading: false,
    forecast_popup_loaded: false,
    basics: '',
    aggregate: '',
    cat_levels: [],
    filter_data: {
        location: [],
        period: 1,
        selected_period: '1-week',
        aggregate: "week",
        num_period: 1,
        type: 'product',
        start_date: moment().format('YYYY-MM-DD'),
    },
    filter_data_cat: {
        basics: '',
        departments: [],
        categories: [],
        subcategories: [],
        products: []
    },
    category_data_type:{
        department: false,
        store: false,
        product: false,
        date: false
    },
    product_col_data: [],
    department_col_data: [],
    product_date_col_data: [],
    approve_dates_list: [],
    product_outlet_name: '',
    selected_outlet: '',
    product_name: '',
    product_id: '',
    dept_id: '',
    breadcrumbs_data: [],
    selected_sku_date: '',
    selected_dates: {}
};

const mutations = {
    SET_STORES_LIST(state, data){
        state.stores_list = data;
    },
    SET_ALL_FORECAST_DATA(state, data){
        state.all_forecast_data = data;
    },
    SET_COL_FORECAST_DATA(state, data){
        state.col_forecast_data = data;
    },
    SET_NAME_MAPPING_DATA(state, data){
        state.name_mapping_data = data;
    },
    HANDLE_TABLE_LOADING(state, data){
        state.sfl_table_loading = data;
    },
    HANDLE_STORE_LVL_TABLE(state, data){
        state.is_store_level_table = data;
    },
    SET_STORE_FORECAST_DATA(state, data){
        state.store_forecast_data = data;
    },
    SET_SELECTED_APPROVE_DAT(state, data){
        state.set_selected_approve_date = data;
    },
    SET_FORECAST_APPROVE_DATA(state, data){
        state.forecast_approve_data = data;
    },
    HANDLE_FORECAST_LOADING(state, data){
        state.forecast_popup_loading = data;
    },
    HANDLE_FORECAST_DATA_LOAD(state, data){
        state.forecast_popup_loaded = data;
    },
    SET_STORE_EVENTS(state, data){
        state.store_events = data;
    },
    SET_EVENT_CATEGORIES(state, data){
        state.event_categories = data;
    },
    SET_FORECAST_APPROVE_GRAPH_DATA(state, data){
        console.log(state.forecast_approve_data, 'state.forecast_approve_data')
        let arr = [];
        arr.push(state.forecast_approve_data.sale_year.sales);
        arr.push(state.forecast_approve_data.sale_week.sales);
        arr.push(state.forecast_approve_data.trend.trend_transactions);
        arr.push(state.forecast_approve_data.forecast.sales);
        console.log(arr, 'arr')
        state.forecast_graph_data = arr;
    },
    SET_SELECTED_STORE_NAME(state, data){
        state.selected_store_level = data.name;
        state.selected_store_id = data.id[0];
    },
    SET_BASICS(state, data){
        state.basics = data;
    },
    SET_AGGREGATE(state, data){
        state.aggregate = data;
    },
    SET_CAT_LEVELS(state, data){
        state.cat_levels.push({name:data.name, id: data.id});
    },
    CLEAR_CAT_LEVELS(state, data){
        state.cat_levels = [];
    },
    SET_FILTER_OPTIONS(state, data){
        state.filter_data = data;
    },
    SET_FILTER_OPTIONS_CAT(state, data){
        state.filter_data_cat = data;
    },
    SET_CATEGORY_DATA_TYPE(state, data){
        state.category_data_type[data.type] = data.value;
    },
    SET_DEPARTMENT_COL_DATA(state, data){
        state.department_col_data = data;
    },
    SET_PRODUCT_COL_DATA(state, data){
        state.product_col_data = data;
    },
    SET_PRODUCT_DATE_COL_DATA(state, data){
        state.product_date_col_data = data;
    },
    SET_PRODUCT_OUTLET_NAME(state, data){
        state.product_outlet_name = data;
    },
    SET_PRODUCT_OUTLET_ID(state, data){
        state.selected_outlet = data;
    },
    SET_OUTLET_PRODUCT_NAME(state, data){
        state.product_name = data;
    },
    SET_OUTLET_PRODUCT_ID(state, data){
        state.product_id = data;
    },
    SET_APPROVE_DATES_LIST(state, data){
        state.approve_dates_list = data;
    },
    SET_BREADCRUMBS_DATA(state, data){
        state.breadcrumbs_data.push({type: data.type, name:data.name, id:data.id});
    },
    SET_NEW_BREADCRUMBS_DATA(state, data){
        state.breadcrumbs_data = data;
    },
    CLEAR_BREADCRUMBS_DATA(state, data){
        state.breadcrumbs_data = [];
    },
    SET_DEPT_ID(state, data){
        state.dept_id = data;
    },
    SET_SELECTED_SKU_DATE(state, data){
        state.selected_sku_date = data;
    },
    SET_FROM_TO_DATE(state, data){
        state.selected_dates = data;
    },
};

const actions = {
    clearBreadCrumbsAction({commit,dispatch}){
        commit('CLEAR_CAT_LEVELS', []);
    },
    getStoreDataAction({commit,dispatch}, is_cleared=false){
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:true});
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:true});
        commit('CLEAR_BREADCRUMBS_DATA');
        // For category only 
        if(is_cleared) {
            commit('SET_PRODUCT_OUTLET_NAME', '');
            commit('SET_SELECTED_SKU_DATE', '');
        }
        
		api.getAllStoreData().then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            for (const store of data) { id_list.push(store.id) }
            data.unshift({name:"All Location", id:'all'})
			commit('SET_STORES_LIST', data);
            let obj = {
                "include_start_day": true,
                "view": "amt",
                "basics": "outlet",
                "filters": {
                    "outlets": state.filter_data.location,
                    "departments": [],
                    "categories": [],
                    "subcategories": [],
                    "products": []
                },
                "extra_keys": "trans",
                "num_period": state.filter_data.num_period,
                "aggregate": state.filter_data.aggregate,
                "start_date": moment(state.filter_data.start_date).format("YYYY-MM-DD")
            };
             // CHange route wise
             if(router.currentRoute.name === 'SalesCategoryForecast') {
                obj.num_period = state.filter_data.selected_period.split('-').includes('week') ?  1 : state.filter_data.num_period
                obj.aggregate = state.filter_data.aggregate
                obj.basics = 'outlet'
                obj.extra_keys = 'qty'
                obj.type = 'product'
                obj.include_start_day = true
                commit('SET_BASICS', 'product');
                commit('SET_AGGREGATE', 'day');
            }
            if(is_cleared){
                commit('CLEAR_CAT_LEVELS');
            }
            // state.stores_list.length ? obj.filters.outlets.push(state.stores_list[0].id) : '';
            let query_params = {currentPage: 1, pageSize: 10};
            let payload = {obj,query_params};
            let nameMapPayload = {basics:'outlet', id_list};
            dispatch('getAllForecastDataAction', payload);
            dispatch('getColForecastDataAction', obj);
            if(router.currentRoute.name !== 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', nameMapPayload);
            }
            if(router.currentRoute.name === 'SalesLocationForecast'){
                commit('SET_FILTER_OPTIONS_CAT', {basics: payload.obj.basics ,...payload.obj.filters});
            }
		}).catch((err)=>{
			console.error(err)
		});
	},
    getAllForecastDataAction({commit, dispatch}, payload){
        if(payload.obj.aggregate==="day"){
            commit('HANDLE_STORE_LVL_TABLE', true);
        }
        commit('HANDLE_STORE_LVL_TABLE', false);
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_FILTER_OPTIONS_CAT', {basics: payload.obj.basics ,...payload.obj.filters});
        commit('SET_AGGREGATE', payload.obj.aggregate);
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            let arr = [];
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }
            let nameMapPayload = {basics:'outlet', id_list};
            if(router.currentRoute.name === 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', nameMapPayload);
            }
			commit('SET_ALL_FORECAST_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    loadBasicsWiseCategoryData({commit, dispatch}, product){
        commit('HANDLE_TABLE_LOADING', true);
        if(state.basics === 'category'){
            commit('SET_BASICS', 'subcategory');
            commit('SET_CAT_LEVELS', product);
        } else if(state.basics === 'subcategory'){
            commit('SET_BASICS', 'product');
            commit('SET_CAT_LEVELS', product);
        } else if(state.basics === 'product') {
            commit('SET_BASICS', 'date');
            commit('SET_CAT_LEVELS', product);
        }
        commit('HANDLE_STORE_LVL_TABLE', false);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": "outlet",
            "filters": {
                "outlets": [],
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": []
            },
            "extra_keys": "trans",
            "num_period": 1,
            "aggregate": "week",
            "start_date": moment().format('YYYY-MM-DD')
        };
         // CHange route wise
         if(router.currentRoute.name === 'SalesCategoryForecast') {
            obj.basics = state.basics
            obj.num_period =  state.filter_data.num_period
            obj.aggregate = state.filter_data.aggregate
            obj.start_date = moment(state.filter_data.start_date).format('YYYY-MM-DD')
            obj.extra_keys = 'qty'
            obj.type = 'product'
            obj.include_start_day = true
            if(state.basics === 'subcategory'){
                obj.filters.categories = [product.id]
            }else if(state.basics === 'product') {
                obj.filters.subcategories = [product.id]
            }else if(state.basics === 'date') {
                obj.filters.products = [product.id]
            }
        }
        // state.stores_list.length ? obj.filters.outlets.push(state.stores_list[0].id) : '';
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
        commit('SET_FILTER_OPTIONS_CAT', {basics: obj.basics , ...obj.filters});
        commit('SET_AGGREGATE', obj.aggregate);
        if(payload.obj.aggregate==="day"){
            commit('HANDLE_STORE_LVL_TABLE', true);
        }
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            if(state.basics === 'date') {
                id_list = [product.id];
            } else {
                for (const store of data.results) { id_list.push(Object.keys(store)[0]) }
            }
            let nameMapPayload = {basics: (state.basics === 'date') ? 'outlet' : state.basics, id_list};
            if(router.currentRoute.name === 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', nameMapPayload);
            }
            if(state.filter_data.selected_period==="custom"){
                commit('SET_STORE_FORECAST_DATA', data);
            }else{
                commit('SET_ALL_FORECAST_DATA', data);
            }
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    loadStoreDataAction({commit, dispatch}, param){
        commit('SET_SELECTED_STORE_NAME', {name: param.name, id: param.outlet});
        commit('HANDLE_STORE_LVL_TABLE', true);
        commit('HANDLE_TABLE_LOADING', true);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": "date",
            "filters": {
                "outlets": param.outlet,
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": []
            },
            "extra_keys": "trans",
            "num_period": state.filter_data.num_period,
            "aggregate": state.filter_data.aggregate,
            "start_date": moment(state.filter_data.start_date).format("YYYY-MM-DD")
        };
        // console.log( state.filter_data.num_period, ' state.filter_data.num_period')
         // CHange route wise
         if(router.currentRoute.name === 'SalesCategoryForecast') {
            obj.basics = 'product'
            obj.extra_keys = 'qty'
            obj.type = 'product'
            obj.include_start_day = true
        }
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
        let mapped_name_payload = {"basics": "outlet", "id_list": param.outlet };
        if(router.currentRoute.name !== 'SalesCategoryForecast') {
            dispatch('getnameMappingDataAction', mapped_name_payload);
        }
        commit('SET_FILTER_OPTIONS_CAT', {basics: obj.basics , ...obj.filters});
        commit('SET_AGGREGATE', payload.obj.aggregate);
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }
            let mapped_name_payload = {"basics": "product", "id_list": id_list };
            if(router.currentRoute.name === 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', mapped_name_payload);
            }
			commit('SET_STORE_FORECAST_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    loadStoreDataActionPaginated({commit, dispatch}, param){
        // commit('SET_SELECTED_STORE_NAME', {name: param.name, id: param.outlet});
        commit('HANDLE_STORE_LVL_TABLE', true);
        commit('HANDLE_TABLE_LOADING', true);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": "date",
            "filters": {
                "outlets": param.outlet,
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": []
            },
            "extra_keys": "trans",
            "num_period": state.filter_data.num_period,
            "aggregate": state.filter_data.aggregate,
            "start_date": moment(state.filter_data.start_date).format("YYYY-MM-DD")
        };
        // console.log( state.filter_data.num_period, ' state.filter_data.num_period')
         // CHange route wise
         if(router.currentRoute.name === 'SalesCategoryForecast') {
            obj.basics = 'product'
            obj.extra_keys = 'qty'
            obj.type = 'product'
            obj.include_start_day = true
        }
        let query_params = {currentPage: param.page, pageSize: param.size};
        let payload = {obj,query_params};
        let mapped_name_payload = {"basics": "outlet", "id_list": param.outlet };
        if(router.currentRoute.name !== 'SalesCategoryForecast') {
            dispatch('getnameMappingDataAction', mapped_name_payload);
        }
        commit('SET_FILTER_OPTIONS_CAT', {basics: obj.basics , ...obj.filters});
        commit('SET_AGGREGATE', payload.obj.aggregate);
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }
            let mapped_name_payload = {"basics": "product", "id_list": id_list };
            if(router.currentRoute.name === 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', mapped_name_payload);
            }
			commit('SET_STORE_FORECAST_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    loadStoreDataActionPaginated2({commit,dispatch}, param){
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:true});
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:true});
        commit('CLEAR_BREADCRUMBS_DATA');
        // For category only 
        // if(is_cleared) {
        //     commit('SET_PRODUCT_OUTLET_NAME', '');
        //     commit('SET_SELECTED_SKU_DATE', '');
        // }
        
		api.getAllStoreData().then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            for (const store of data) { id_list.push(store.id) }
            data.unshift({name:"All Location", id:'all'})
			commit('SET_STORES_LIST', data);
            let obj = {
                "include_start_day": true,
                "view": "amt",
                "basics": "outlet",
                "filters": {
                    "outlets": state.filter_data.location,
                    "departments": [],
                    "categories": [],
                    "subcategories": [],
                    "products": []
                },
                "extra_keys": "trans",
                "num_period": state.filter_data.num_period,
                "aggregate": state.filter_data.aggregate,
                "start_date": moment(state.filter_data.start_date).format("YYYY-MM-DD")
            };
             // CHange route wise
             if(router.currentRoute.name === 'SalesCategoryForecast') {
                obj.num_period = state.filter_data.selected_period.split('-').includes('week') ?  1 : state.filter_data.num_period
                obj.aggregate = state.filter_data.aggregate
                obj.basics = 'outlet'
                obj.extra_keys = 'qty'
                obj.type = 'product'
                obj.include_start_day = true
                commit('SET_BASICS', 'product');
                commit('SET_AGGREGATE', 'day');
            }
            // if(is_cleared){
            //     commit('CLEAR_CAT_LEVELS');
            // }
            // state.stores_list.length ? obj.filters.outlets.push(state.stores_list[0].id) : '';
            let query_params = {currentPage: param.page, pageSize: param.size};
            let payload = {obj,query_params};
            let nameMapPayload = {basics:'outlet', id_list};
            dispatch('getAllForecastDataAction', payload);
            dispatch('getColForecastDataAction', obj);
            if(router.currentRoute.name !== 'SalesCategoryForecast') {
                dispatch('getnameMappingDataAction', nameMapPayload);
            }
            if(router.currentRoute.name === 'SalesLocationForecast'){
                commit('SET_FILTER_OPTIONS_CAT', {basics: payload.obj.basics ,...payload.obj.filters});
            }
		}).catch((err)=>{
			console.error(err)
		});
    },
    loadDateWiseForecastData({commit, dispatch}, param){
        // commit('SET_SELECTED_STORE_NAME', {name: param.name, id: param.outlet});
        commit('HANDLE_STORE_LVL_TABLE', true);
        commit('HANDLE_TABLE_LOADING', true);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": "date",
            "filters": {
                "outlets": [state.selected_store_id],
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": []
            },
            "extra_keys": "trans",
            "num_period": 6,
            "aggregate": 'day',
            "start_date": moment(param.date).format("YYYY-MM-DD")
        };
         // CHange route wise
         if(router.currentRoute.name === 'SalesCategoryForecast') {
            // obj.basics = 'category'
            obj.extra_keys = 'qty'
            obj.type = 'product'
            obj.include_start_day = true
        }
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
        let mapped_name_payload = {"basics": "outlet", "id_list": param.outlet };
        if(router.currentRoute.name !== 'SalesCategoryForecast') {
            dispatch('getnameMappingDataAction', mapped_name_payload);
        }
        commit('SET_FILTER_OPTIONS_CAT', {basics: obj.basics , ...obj.filters});
        commit('SET_AGGREGATE', payload.obj.aggregate);
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let arr = [];
            // console.log(data, 'dddd')
            if(data.results.length){
                data.results.map((e)=>{
                    arr.push(Object.keys(e)[0]);
                    commit('SET_APPROVE_DATES_LIST', arr);
                });
            }
			commit('SET_STORE_FORECAST_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getColForecastDataAction({commit}, payload){
		forecast_api.getAllForecast(payload).then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_COL_FORECAST_DATA', data);
		}).catch((err)=>{
			console.error(err)
		});
	},
    loadApproveForecastData({commit,dispatch}){
        // Call forecast API
        // dispatch('callForecastApi', { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: "forecast", date_offset: null});
        // dispatch('callForecastApi', { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: "sale", date_offset: 'week'});
        // dispatch('callForecastApi', { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: "sale", date_offset: 'year'});
        let type = (router.currentRoute.name === 'SalesCategoryForecast') ? 'qty' : 'sale';
        let obj = {
            forecast: { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: "forecast", date_offset: null},
            week: { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: type, date_offset: 'week'},
            year: { date: state.set_selected_approve_date, outlet: state.selected_store_id, type: type, date_offset: 'year'},
        }
        // sssssss
        dispatch('callForecastApi', obj);
        // Call Events API
        let event_obj = {
            "from_date": state.set_selected_approve_date,
            "to_date": state.set_selected_approve_date,
            "res_type": "date_mul",
            "filters": {
                "outlets": [
                    state.selected_store_id
                ],
                "countries": [],
                "regions": [],
                "subregions": []
            }
        };
        dispatch('callEventsApi', event_obj)
	},
    loadEventsDataAction({commit,dispatch}){
        let event_obj = {
            "from_date": state.set_selected_approve_date,
            "to_date": state.set_selected_approve_date,
            "res_type": "date_mul",
            "filters": {
                "outlets": [
                    state.selected_store_id
                ],
                "countries": [],
                "regions": [],
                "subregions": []
            }
        };
        dispatch('callEventsApi', event_obj);
    },
    callForecastApi({commit}, payload){
        commit('HANDLE_FORECAST_LOADING', true);
        commit('HANDLE_FORECAST_DATA_LOAD', false);
        forecast_api.allForecastQueryDetail(payload).then(axios.spread((
            forecastRes,
            weekRes,
            yearRes,
            trendRes
        )=>{
            if( forecastRes.status == 200 &&
                weekRes.status == 200 &&
                yearRes.status == 200 &&
                trendRes.status == 200
            ) {
                let forecastData = JSON.parse(forecastRes.data);
                let weekData = JSON.parse(weekRes.data);
                let yearData = JSON.parse(yearRes.data);
                let trendData = JSON.parse(trendRes.data);
                let obj = {
                    forecast: forecastData,
                    sale_week: weekData,
                    sale_year: yearData,
                    trend: trendData
                };
                commit('SET_FORECAST_APPROVE_DATA', obj);
                commit('HANDLE_FORECAST_LOADING', false);
                commit('HANDLE_FORECAST_DATA_LOAD', true);
                commit('SET_FORECAST_APPROVE_GRAPH_DATA');
            }
        })).catch((err)=>{
            console.error(err);
        }).finally(()=>{
            EventBus.$emit("renderDayForecastGraph")
        });


        // forecast_api.forecastQueryDetail(payload).then((res)=>{
		// 	let data = JSON.parse(res.data);
        //     let obj = {type:null,data:data}
        //     if(payload.date_offset === null){
        //         obj.type = 'forecast';
        //     }else if(payload.date_offset === 'week'){
        //         obj.type = 'sale_week'; 
        //     }else if(payload.date_offset === 'year'){
        //         obj.type = 'sale_year';
        //     }
		// 	commit('SET_FORECAST_APPROVE_DATA', obj);
        //     commit('SET_FORECAST_APPROVE_GRAPH_DATA');
		// }).catch((err)=>{
		// 	console.error(err)
		// });
    },
    callEventsApi({commit}, payload){
        // get events
		api.getStoreEvents(payload).then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_STORE_EVENTS', data);
		}).catch((err)=>{
			console.error(err)
		});
        // Event categories
		api.getEventyCategory().then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_EVENT_CATEGORIES', data);
		}).catch((err)=>{
			console.error(err)
		});
	},
    getnameMappingDataAction({commit}, payload){
        if(payload.id_list)
		forecast_api.mapIds(payload).then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_NAME_MAPPING_DATA', data);
		}).catch((err)=>{
			console.error(err)
		});
	},
    // New actions for category
    callBreadCrumbDataAction({commit, dispatch},payload){
        console.log(payload,'payload');
        if(payload.type==='department'){
            dispatch('getDeptWiseDateData', {department: [payload.id], name: payload.name});
        }else if(payload.type==='product'){
            dispatch('getProductWiseDateData', {product: [payload.id], name: payload.name});
        }else if(payload.type==='outlet'){
            dispatch('getStoreWiseProductData', {outlet: [payload.id], name: payload.name});
        }
    },
    getStoreWiseProductData({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'department', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('HANDLE_STORE_LVL_TABLE', false);
        commit('SET_PRODUCT_OUTLET_NAME', param.name);
        commit('SET_PRODUCT_OUTLET_ID', param.outlet);
        if(state.breadcrumbs_data.some((e)=> e.type=== 'department')){
            let final_data = state.breadcrumbs_data.filter((e)=> e.type !== 'department')
            commit('SET_NEW_BREADCRUMBS_DATA', final_data);
        }
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'department',
            "filters": {
                "outlets": param.outlet,
                "departments": state.filter_data_cat.departments,
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.num_period,
            "aggregate": state.filter_data.aggregate,
            "start_date": moment(state.filter_data.start_date).format('YYYY-MM-DD'),
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            let nameMapPayload = {basics: 'department', id_list};
            dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_DEPARTMENT_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_DEPARTMENT_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getStoreWiseSKUData({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'department', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:true});
        commit('HANDLE_STORE_LVL_TABLE', false);
        commit('SET_PRODUCT_OUTLET_NAME', param.name);
        commit('SET_PRODUCT_OUTLET_ID', param.outlet);
        if(state.breadcrumbs_data.some((e)=> e.type=== 'product')){
            let final_data = state.breadcrumbs_data.filter((e)=> e.type !== 'product')
            commit('SET_NEW_BREADCRUMBS_DATA', final_data);
        }
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'date',
            "filters": {
                "outlets": param.outlet,
                "departments": state.filter_data_cat.departments,
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.aggregate === 'week' ? 6 : state.filter_data.num_period,
            "aggregate": 'day',
            "start_date": state.filter_data.aggregate === 'week' ?  moment().clone().startOf('week').add(1, 'days').format('YYYY-MM-DD') : moment(state.filter_data.start_date).format('YYYY-MM-DD'),
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            // let nameMapPayload = {basics: 'department', id_list};
            // dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_DATE_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_PRODUCT_DATE_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getSKUDateData({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'department', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('SET_SELECTED_SKU_DATE', param.date[0]);
        commit('HANDLE_STORE_LVL_TABLE', false);
        if(state.breadcrumbs_data.some((e)=> e.type=== 'product')){
            let final_data = state.breadcrumbs_data.filter((e)=> e.type !== 'product')
            commit('SET_NEW_BREADCRUMBS_DATA', final_data);
        }
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'product',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": state.filter_data_cat.departments,
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": 0,
            "aggregate": 'day',
            "start_date": param.date[0],
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastAll(payload.obj).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data) { id_list.push(Object.keys(store)[0]) }

            let nameMapPayload = {basics: 'product', id_list};
            dispatch('getnameMappingDataAction', nameMapPayload);
            console.log(data, 'data')
            commit('SET_PRODUCT_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_PRODUCT_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    callSKUPaginatedApi({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('HANDLE_STORE_LVL_TABLE', false);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'product',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": state.filter_data_cat.departments,
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": 1,
            "aggregate": 'day',
            "start_date": state.selected_sku_date,
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: param.page, pageSize: param.size};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            let nameMapPayload = {basics: 'product', id_list};
            dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_PRODUCT_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getDeptWiseDateData({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'department', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        if(!state.breadcrumbs_data.some((e)=> e.type=== 'department')){
            commit('SET_BREADCRUMBS_DATA', {type:'department', name:param.name, id:param.department[0]});
        }
        if(state.breadcrumbs_data.some((e)=> e.type=== 'product')){
            let final_data = state.breadcrumbs_data.filter((e)=> e.type !== 'product')
            commit('SET_NEW_BREADCRUMBS_DATA', final_data);
        }
        commit('HANDLE_STORE_LVL_TABLE', false);
        // commit('SET_PRODUCT_OUTLET_NAME', param.name);
        commit('SET_DEPT_ID', param.department[0]);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'product',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": param.department,
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.num_period,
            "aggregate": state.filter_data.aggregate,
            "start_date": moment(state.filter_data.start_date).format('YYYY-MM-DD'),
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            let nameMapPayload = {basics: 'product', id_list};
            dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_PRODUCT_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    callPaginatedApi({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:false});
        commit('HANDLE_STORE_LVL_TABLE', false);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'product',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": [state.dept_id],
                "categories": state.filter_data_cat.departments,
                "subcategories": state.filter_data_cat.departments,
                "products": state.filter_data_cat.departments
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.num_period,
            "aggregate": state.filter_data.aggregate,
            "start_date": moment(state.filter_data.start_date).format('YYYY-MM-DD'),
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: param.page, pageSize: param.size};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            let nameMapPayload = {basics: 'product', id_list};
            dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_COL_DATA', data);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
            commit('SET_PRODUCT_COL_DATA', []);
			console.error(err);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getProductWiseDateData({commit, dispatch}, param){
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('HANDLE_STORE_LVL_TABLE', false);
        commit('SET_OUTLET_PRODUCT_NAME', param.name);
        commit('SET_OUTLET_PRODUCT_ID', param.product);
        commit('SET_AGGREGATE',  state.filter_data.aggregate);
        if(!state.breadcrumbs_data.some((e)=> e.type=== 'product')){
            commit('SET_BREADCRUMBS_DATA', {type:'product', name:param.name, id:param.product[0]});
        }
        if(state.breadcrumbs_data.some((e)=> e.type=== 'week')){
            let final_data = state.breadcrumbs_data.filter((e)=> e.type !== 'week')
            commit('SET_NEW_BREADCRUMBS_DATA', final_data);
        }
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'date',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": param.product
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.num_period, // state.filter_data.aggregate === week ? state.filter_data.num_period * 6 : state.filter_data.num_period
            "aggregate": state.filter_data.aggregate, // day
            "start_date": moment(state.filter_data.start_date).format('YYYY-MM-DD'),
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            // let nameMapPayload = {basics: state.filter_data.type, id_list};
            // dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_DATE_COL_DATA', data.results);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('SET_PRODUCT_DATE_COL_DATA', []);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
    getProductWiseWeekData({commit, dispatch}, param){
        console.log(param,'param')
        commit('HANDLE_TABLE_LOADING', true);
        commit('SET_CATEGORY_DATA_TYPE', {type:'date', value:true});
        commit('SET_CATEGORY_DATA_TYPE', {type:'product', value:false});
        commit('SET_CATEGORY_DATA_TYPE', {type:'store', value:false});
        commit('HANDLE_STORE_LVL_TABLE', false);
        commit('SET_AGGREGATE',  'day');
        if(!state.breadcrumbs_data.some((e)=> e.type=== 'week')){
            commit('SET_BREADCRUMBS_DATA', {type:'week', name:param.week[0], id:param.week[0]});
        }
        // commit('SET_OUTLET_PRODUCT_NAME', param.name);
        let obj = {
            "include_start_day": true,
            "view": "amt",
            "basics": 'date',
            "filters": {
                "outlets": state.selected_outlet,
                "departments": [],
                "categories": [],
                "subcategories": [],
                "products": state.product_id
            },
            "extra_keys": "qty",
            "num_period": state.filter_data.aggregate === 'week' ? 1 : state.filter_data.num_period, // state.filter_data.aggregate === week ? state.filter_data.num_period * 6 : state.filter_data.num_period
            "aggregate": 'day', // day
            "start_date": param.week[0],
            "type": state.filter_data.type
        };
        
        let query_params = {currentPage: 1, pageSize: 10};
        let payload = {obj,query_params};
		forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
			let data = JSON.parse(res.data);
            let id_list = [];
            
            for (const store of data.results) { id_list.push(Object.keys(store)[0]) }

            // let nameMapPayload = {basics: state.filter_data.type, id_list};
            // dispatch('getnameMappingDataAction', nameMapPayload);
            commit('SET_PRODUCT_DATE_COL_DATA', data.results);
            commit('HANDLE_TABLE_LOADING', false);
		}).catch((err)=>{
			console.error(err);
            commit('SET_PRODUCT_DATE_COL_DATA', []);
            commit('HANDLE_TABLE_LOADING', false);
		});
	},
};

const getters = {
    getMappedName: (state) => (id) => {
        let mapped = {};
        mapped = state.name_mapping_data.find((e)=> e.id===id);
        if(mapped)
        return Object.keys(mapped).length ? mapped.name : '-';
    }
};

export default {
	state,
	mutations,
	actions,
    getters,
	namespaced: true
};
